export const WAREHOUSE_PRODUCT_SELECTION_TITLE = 'productos del almacén';

export interface IWarehouseProductBase {
  lot: string;
  expAt: string;
  quantity: number;
  purchasePrice: string;
  productOfProviderCode: string;
  productOfProviderDescription: string;
  unitMeasureDescription: string;
  unitMeasureSymbol: string;
  providerRuc: string;
  providerName: string;
}

export interface IWarehouseProduct extends IWarehouseProductBase {
  id: number;
}
